import React from "react";

export default function ButtonSalvar({
  onClick,
  texto = "Salvar",
  disabled = false,
}) {
  const handleClick = (e) => {
    e.preventDefault();
    if (onClick && !disabled) onClick(e);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled}
      className={`px-7 py-2.5 rounded-sm text-white font-medium transition-all duration-200 active:scale-[0.98] ${
        disabled ? "opacity-70 cursor-not-allowed" : ""
      }`}
      style={{
        backgroundColor: disabled ? "#9ca3af" : "#16a34a",
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
      }}
      onMouseEnter={(e) =>
        !disabled && (e.target.style.backgroundColor = "#18b34f")
      }
      onMouseLeave={(e) =>
        !disabled && (e.target.style.backgroundColor = "#16a34a")
      }
    >
      {texto}
    </button>
  );
}
